import { axiosMediaBuilder as axiosFetch } from "./axiosMediaBuilder";
import type {
  MediaType,
  MediaItem,
  CreateMediaRequest,
  UpdateMediaRequest,
} from "./contracts";

export async function getMedia(
  type: MediaType,
  includeUserMedia?: boolean,
  reservationId?: string
): Promise<MediaItem[]> {
  let url = `/api/media?type=${type}`;
  if (includeUserMedia) {
    url += "&includeUserMedia=true";
  }
  if (reservationId) {
    url += `&reservationId=${reservationId}`;
  }

  return axiosFetch.safeGet<MediaItem[], any, any>(url);
}

export async function getMediaById(
  mediaId: string,
  includeContent?: boolean
): Promise<MediaItem> {
  let url = `/api/media/${mediaId}`;
  if (includeContent) {
    url += "?includeContent=true";
  }
  return axiosFetch.safeGet<MediaItem, any, any>(url);
}

export async function addMedia(body: CreateMediaRequest): Promise<MediaItem> {
  const response = await axiosFetch.safePost<
    CreateMediaRequest,
    any,
    any,
    MediaItem
  >("/api/media", body);
  return response.data;
}

export async function updateMedia(mediaId: string, body: UpdateMediaRequest) {
  return axiosFetch.put(`/api/media/${mediaId}`, body);
}

export async function deleteMedia(mediaId: string) {
  return axiosFetch.del(`/api/media/${mediaId}`);
}
